import { observer } from 'mobx-react-lite'
import { AdvanceJobsDialog } from '@/features/jobs/list/components/AdvanceJobsDialog'
import { type AdvanceJobsDialogViewModel } from './AdvanceJobsDialogViewModel'

export interface AdvanceJobsDialogContainerProps {
  vm: AdvanceJobsDialogViewModel
}

export const AdvanceJobsDialogContainer = observer(
  function AdvanceJobsDialogContainer({ vm }: AdvanceJobsDialogContainerProps) {
    return (
      <AdvanceJobsDialog
        showing={vm.modal.showing}
        jobsCount={vm.jobsCount}
        earlyAdvanceJobsCount={vm.earlyAdvanceJobsCount}
        isPending={vm.advanceJobs.pending}
        onConfirm={vm.advanceJobs}
        onDecline={vm.modal.close}
      />
    )
  },
)
